module.exports = __webpack_public_path__ + "img/right-info-open02.4c4e62b4.png";